import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function setCustomerComment(
    deliveryId: number,
    reference: string | undefined,
    comment?: string,
) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop
        .post(
            getUrl(`/baskets/${reference}/update/customercomment/${deliveryId}?comment=${comment}`),
        )
        .json<ShopTypes.BasketResponse>();
}
